import { render, staticRenderFns } from "./SectionLoanFee.vue?vue&type=template&id=08b591df&scoped=true&"
import script from "./SectionLoanFee.vue?vue&type=script&lang=js&"
export * from "./SectionLoanFee.vue?vue&type=script&lang=js&"
import style0 from "./SectionLoanFee.vue?vue&type=style&index=0&id=08b591df&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b591df",
  null
  
)

export default component.exports